import { configureStore } from './configureStore';
import pathViewerReducer from '../reducers/pathViewer';

export default function pathViewerStore(initialState) {
  return configureStore(initialState, {
    pathViewer: pathViewerReducer,
  });
}
